import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { UnsoldDescriptionService } from '../../../services/index';
import { AddEditUnsoldDescriptionComponent } from './addEditUnsoldDescription.component';

@Component({
    selector: 'unsold-description-tab',
    templateUrl: './unsoldDescription.component.html',
})
export class UnsoldDescriptionMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    unsoldDescriptionData: any[] = [];
    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'name',
        orderDir: 'asc'
    };

    filterData = { search_data: '' };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    constructor(
        private unsoldDescriptionService: UnsoldDescriptionService,
        private modalService: BsModalService,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Unsold Description', prop: 'name', cellClass: 'cell-left', width: 300, minWidth: 300, maxWidth: 300 },
            { name: 'Status', prop: 'status', cellClass: 'cell-left', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Action', prop: 'sno', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (this.suppressPaging) { return; }
        this.page.offset = pageInfo.offset;
        this.getUnsoldDescriptionList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getUnsoldDescriptionList();
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() { $('#filterSearch').focus(); }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getUnsoldDescriptionList();
    }

    clearFilter(): void {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getUnsoldDescriptionList();
    }

    getUnsoldDescriptionList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.unsoldDescriptionService
            .getUnsoldDescriptionList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.unsoldDescriptionData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditUnsoldDescription(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditUnsoldDescriptionComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Unsold Description';
        this.bsModalRef.content.unsoldDescriptionData = Object.assign({}, row);
        this.bsModalRef.content.unsoldDescriptionLoadEvent.subscribe(($e) => {
            that.getUnsoldDescriptionList();
        });
    }

    onDeleteUnsoldDescription(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.unsoldDescriptionService
                .deleteUnsoldDescription({ id: row.id })
                .then(function(res: any) {
                    if (res.success) {
                        that.getUnsoldDescriptionList();
                        swal('Deleted', res.message, 'success');
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }, function(dismiss) { });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/unsoldDescription/unsoldDescription.component.ts